// import { useState, useEffect, useCallback } from 'react';
// import { GiCow, GiFarmer, GiFarmTractor, GiPerson } from 'react-icons/gi';
import { Card, CardContent, CardHeader, Grid } from '@mui/material';
import { WelcomeContainer } from 'styles/views/Dashboard';

// import PromoterDashboard from '../../components/Dashboards/Promoter';
// import { get } from 'api/api';
// import CardData from 'components/CardData';
// import Table from 'components/Table';

export default function Dashboard() {
  // const [animais, setAnimais] = useState([]);
  // const [loading, setLoading] = useState(false);
  // const [dashboard, setDashboard] = useState({
  //   animais: '...',
  //   fazendas: '...',
  //   consultores: '...',
  //   produtores: '...',
  // });

  // const [fazenda] = useState(() => {
  //   return JSON.parse(sessionStorage.getItem('fazenda') || '{}');
  // });

  // const fetchAnimais = useCallback(async () => {
  //   if (fazenda && fazenda.CodFazenda) {
  //     setLoading(true);
  //     try {
  //       const res = await get(`animal/byfazenda/${fazenda.CodFazenda}`);
  //       setAnimais(res.data.data);
  //     } catch (err) {
  //       console.error(err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  // }, [fazenda]);

  // const fetchUsers = async () => {
  //   setLoading(true);
  //   try {
  //     const res = await get('users');
  //     console.log(res);
  //   } catch (err) {
  //     console.error(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const fetchDashboardData = async () => {
  //   try {
  //     const result = await get('dashboard');
  //     setDashboard(result.data);
  //   } catch (err) {
  //     console.error(err);
  //     setDashboard({
  //       animais: '...',
  //       fazendas: '...',
  //       consultores: '...',
  //       produtores: '...',
  //     });
  //   }
  // };

  // useEffect(() => {
  //   fetchAnimais();
  // }, [fazenda, fetchAnimais]);

  // useEffect(() => {
  //   fetchDashboardData();
  //   fetchUsers();
  // }, []);

  return (
    <Grid container spacing={3}>
      <Grid item md={12}>
        <Card>
          <CardHeader title={<WelcomeContainer>Bem-vindo(a) ao Esteio Gestão</WelcomeContainer>} />
          <CardContent className="Mt2">
            <Grid container spacing={3}>
              {/* <Grid item className="mt4" xs={12} md={6} lg={3}>
                <CardData
                  bg="info"
                  footerText="Ver Mais"
                  footer
                  title="Animais"
                  icon={<GiCow />}
                  data={String(dashboard.animais)}
                />
              </Grid>
              <Grid item className="mt4" xs={12} md={6} lg={3}>
                <CardData
                  bg="warning"
                  footerText="Ver Mais"
                  footer
                  title="Fazendas"
                  icon={<GiFarmTractor />}
                  data={String(dashboard.fazendas)}
                />
              </Grid>
              <Grid item className="mt4" xs={12} md={6} lg={3}>
                <CardData
                  bg="error"
                  footerText="Ver Mais"
                  footer
                  title="Produtores"
                  icon={<GiFarmer />}
                  data={String(dashboard.produtores)}
                />
              </Grid>
              <Grid item className="mt4" xs={12} md={6} lg={3}>
                <CardData
                  bg="success"
                  footerText="Ver Mais"
                  footer
                  title="Consultores"
                  icon={<GiPerson />}
                  data={String(dashboard.consultores)}
                />
              </Grid> */}
            </Grid>

            {/* <Table
              title="Animais"
              isLoading={loading}
              columns={[
                { title: 'Nome', field: 'Nome' },
                {
                  title: 'Sexo',
                  field: 'Sexo',
                  render: (rowData: { Sexo: number }) => {
                    return rowData.sexo === 1 ? 'Macho' : 'Fêmea';
                  },
                },
                {
                  title: 'Data de Nascimento',
                  field: 'DataNasc',
                  render: (rowData: { DataNasc: string }) => {
                    const date = new Date(rowData.DataNasc);
                    return date.toLocaleDateString('pt-BR');
                  },
                },
                { title: 'Raça', field: 'Raca.nome' },
                { title: 'Raça 2', field: 'Raca2.nome' },
              ]}
              data={animais}
            /> */}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
